export default __webpack_public_path__ + "static/media/Starjout.f7accd29.ttf";